import clientInstance from "@/lib/clientInstance";

export default {
  namespaced: true,
  state() {
    return {
      recentNews: [],
      socialLinks: [],
    };
  },

  getters: {
    getRecentNews(state) {
      return state.recentNews;
    },

    getSocialLinks(state) {
      return state.socialLinks;
    },
  },

  mutations: {
    setRecentNews(state, payload) {
      state.recentNews = payload;
    },

    setSocialLinks(state, payload) {
      state.socialLinks = payload;
    },
  },

  actions: {
    async fetchRecentNews({ commit }, payload) {
      try {
        const response = await clientInstance.get(
          `/get/recent-news?lang=${payload}`
        );
        if (response.status === 200) {
          commit("setRecentNews", response.data.recentNews);
        }
      } catch (err) {
        return err;
      }
    },

    async fetchSocialLinks({ commit }) {
      try {
        const response = await clientInstance.get("/get/social-links");
        if (response.status === 200) {
          commit("setSocialLinks", response.data.socialLinks);
        }
      } catch (err) {
        return err;
      }
    },
  },
};
